
import React from 'react';
import { IntegrationFlow, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface FlowsListProps {
  language: Language;
  flows: IntegrationFlow[];
  onOpenFlow: (flow: IntegrationFlow) => void;
  onAddFlow: () => void;
  onDeleteFlow: (id: string) => void;
}

const FlowsList: React.FC<FlowsListProps> = ({ language, flows, onOpenFlow, onAddFlow, onDeleteFlow }) => {
  const t = TRANSLATIONS[language];
  return (
    <div className="p-6 lg:p-12 w-full h-full flex flex-col bg-[#050507] overflow-y-auto custom-scrollbar">
        <div className="flex justify-between items-center mb-10">
          <div>
            <h1 className="text-3xl lg:text-5xl font-black text-white mb-2">{t.flowsTitle}</h1>
            <p className="text-slate-400">{t.flowsDesc}</p>
          </div>
          <button onClick={onAddFlow} className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-2xl font-black text-sm shadow-2xl transition-all flex items-center gap-3">
            <i className="fas fa-plus"></i> {t.addFlow}
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {flows.length === 0 && (
             <div className="col-span-full flex flex-col items-center justify-center py-20 opacity-50">
                <i className="fas fa-wind text-6xl mb-4 text-slate-600"></i>
                <p>{t.noFlows}</p>
             </div>
          )}
          {flows.map(flow => (
            <div key={flow.id} onClick={() => onOpenFlow(flow)} className="group bg-[#111115] border border-white/5 hover:border-emerald-500/30 rounded-[32px] p-8 cursor-pointer transition-all hover:-translate-y-1 hover:shadow-2xl">
               <div className="flex justify-between items-start mb-6">
                  <div className={`w-14 h-14 rounded-2xl flex items-center justify-center text-2xl ${flow.active ? 'bg-emerald-500 text-white' : 'bg-white/5 text-slate-500'}`}><i className="fas fa-bolt"></i></div>
                  <button onClick={(e) => { e.stopPropagation(); onDeleteFlow(flow.id); }} className="text-slate-500 hover:text-rose-500"><i className="fas fa-trash"></i></button>
               </div>
               <h3 className="text-xl font-black text-white mb-2">{flow.name}</h3>
               <p className="text-xs text-slate-500 font-mono">{flow.nodes.length} Nodes • {new Date().toLocaleDateString()}</p>
            </div>
          ))}
        </div>
      </div>
  );
};
export default FlowsList;
